var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "favorite favorite__list" },
    [
      _vm.updateMode && _vm.editable
        ? _c("input", {
            attrs: { type: "radio", name: "favorite" },
            domProps: { value: _vm.favorite.id },
            on: {
              change: function($event) {
                return _vm.$emit("input", _vm.favorite.id)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "block flex gray-100 fs-3",
          attrs: { href: "#" },
          on: { click: _vm.load }
        },
        [_vm._v(_vm._s(_vm.favorite.name))]
      ),
      _vm._v(" "),
      _c(
        "CompassMenu",
        {
          ref: "refMenuActions",
          attrs: {
            trigger: "hover",
            placement: "bottom-end",
            customClass: "favorite-item__dropdown"
          }
        },
        [
          _c("CompassIconButton", {
            ref: "settings",
            staticClass: "favorite-item__dropdown-icon",
            attrs: { icon: "action", size: "small" }
          }),
          _vm._v(" "),
          _c(
            "template",
            { slot: "dropdown" },
            [
              _vm.editable
                ? _c("CompassMenuItem", {
                    attrs: { label: _vm.$t.__("common.labels.settings") },
                    on: {
                      click: function($event) {
                        return _vm.$store.dispatch(
                          _vm.listinghash + "/editFavorite",
                          _vm.favorite
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.editable
                ? _c("CompassMenuItem", {
                    attrs: { label: _vm.$t.__("common.labels.see") },
                    on: {
                      click: function($event) {
                        return _vm.$store.dispatch(
                          _vm.listinghash + "/editFavorite",
                          _vm.favorite
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("CompassMenuItem", {
                attrs: {
                  id: "sharelink" + _vm.favorite.id,
                  label: _vm.$t.__("common.labels.share")
                },
                on: { click: _vm.enableSharing }
              }),
              _vm._v(" "),
              !_vm.favorite.shortcut
                ? _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.$t.__("common.labels.set_as_shortcut")
                    },
                    on: { click: _vm.addShortcut }
                  })
                : _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.$t.__("common.labels.remove_shortcut")
                    },
                    on: { click: _vm.removeShortcut }
                  }),
              _vm._v(" "),
              _vm.deletable
                ? _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.$t.__("common.labels.remove_favorite")
                    },
                    on: { click: _vm.openDeleteModal }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }